import type { App } from 'vue';
import { useContextStore } from '@/Stores/context';
import { useQrCodeModal } from '@/Composables/Modal/useQrCodeModal';

let isInstalled = false;
let handler: ((e: MouseEvent) => void) | null = null;

export function installExternalLinkGuard(app: App) {
  if (isInstalled) {
    console.log('ExternalLinkGuard already installed');
    return;
  }

  isInstalled = true;

  handler = (event: MouseEvent) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const path = (event.composedPath && event.composedPath()) || [];
    const target = (path[0] as HTMLElement | undefined) || (event.target as HTMLElement | null);

    if (!target) return;

    const anchor = target.closest('a') as HTMLAnchorElement | null;
    if (!anchor || !anchor.href) return;

    let url: URL;
    try {
      url = new URL(anchor.href, window.location.origin);
    } catch {
      return;
    }

    const isSpecialProtocol = !['http:', 'https:'].includes(url.protocol);
    const isExternal = url.origin !== window.location.origin;

    try {
      const contextStore = useContextStore();

      if (contextStore.isKite && (isExternal || isSpecialProtocol)) {
        event.preventDefault();
        event.stopPropagation();

        const { openQrModal } = useQrCodeModal();
        openQrModal(url.href);
      }
    } catch (error) {
      console.error('Error in ExternalLinkGuard:', error);
    }
  };

  document.addEventListener('click', handler, true);

  // eslint-disable-next-line no-param-reassign
  app.config.globalProperties.$externalLinkGuardCleanup = () => {
    if (handler) {
      document.removeEventListener('click', handler, true);
      handler = null;
      isInstalled = false;
      console.log('ExternalLinkGuard removed');
    }
  };
}
